import { Box, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { passwordRules } from '../../lib/auth/validation';

/**
 * Password-rules checklist.
 *
 * Renders every password policy rule as a row with:
 *   - Green ✓ + normal text when the rule is met
 *   - Red ✗ + normal text when the rule is not met
 *
 * The rows re-color live as the user types so they see the moment
 * each rule is satisfied. Zero-cost pure render — no state, no
 * effects.
 */
export interface PasswordRulesProps {
  readonly value: string;
}

export function PasswordRulesChecklist(props: PasswordRulesProps): JSX.Element {
  const rules = passwordRules(props.value);
  return (
    <Box sx={{ mt: 0.5 }}>
      <Stack spacing={0.5}>
        {rules.map((rule) => (
          <Stack
            key={rule.id}
            direction="row"
            spacing={1}
            sx={{ alignItems: 'center' }}
          >
            {rule.met ? (
              <CheckCircleIcon
                fontSize="small"
                sx={{ color: 'success.main' }}
                aria-label="met"
              />
            ) : (
              <CancelIcon
                fontSize="small"
                sx={{ color: 'error.main' }}
                aria-label="not met"
              />
            )}
            <Typography variant="body2" color="text.secondary">
              {rule.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
